import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import {
  listKnowledgebaseConfig,
  getKnowledgebaseConfig,
  createKnowledgebaseConfig,
  updateKnowledgebaseConfig,
} from '../lib/knowledgebase.url';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  knowledgebaseLoadingSlice,
  knowledgebaseListSlice,
  knowledgebaseItemSlice,
} from '../slices/knowledgebase.slice';

export const listKnowledgebaseAction = (filters = {}) => {
  return async (dispatch) => {
    dispatch(knowledgebaseLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const params = {
        ...filters,
      };
      const { url } = listKnowledgebaseConfig();
      const result = await Axios.get(url, { headers, params });
      if (result?.status === 200) {
        dispatch(knowledgebaseListSlice(result?.data));
      }
    } catch (e) {
      showToastError('Failed to load knowledgebase');
    } finally {
      dispatch(knowledgebaseLoadingSlice(false));
    }
  };
};

export const getKnowledgebaseAction = (knowledgebaseId) => {
  return async (dispatch) => {
    dispatch(knowledgebaseLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const { url } = getKnowledgebaseConfig(knowledgebaseId);
      const result = await Axios.get(url, { headers });
      if (result?.status === 200) {
        dispatch(knowledgebaseItemSlice(result?.data));
      }
    } catch (e) {
      showToastError('Failed to load knowledgebase item');
    } finally {
      dispatch(knowledgebaseLoadingSlice(false));
    }
  };
};

export const updateKnowledgebaseAction = (
  knowledgebaseId,
  payload,
  successCallback
) => {
  return async (dispatch) => {
    dispatch(knowledgebaseLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const { url } = updateKnowledgebaseConfig(knowledgebaseId);
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        dispatch(knowledgebaseItemSlice(result?.data));
        showToastSuccess('Knowledgebase updated successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to update knowledgebase');
    } finally {
      dispatch(knowledgebaseLoadingSlice(false));
    }
  };
};

export const createKnowledgebaseAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch(knowledgebaseLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const { url } = createKnowledgebaseConfig();
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 201) {
        showToastSuccess('Knowledgebase created successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to create knowledgebase');
    } finally {
      dispatch(knowledgebaseLoadingSlice(false));
    }
  };
};

export const deleteKnowledgebaseAction = (knowledgebaseId, successCallback) => {
  return async (dispatch) => {
    dispatch(knowledgebaseLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const { url } = getKnowledgebaseConfig(knowledgebaseId);
      const result = await Axios.delete(url, { headers });
      if (result?.status === 200) {
        showToastSuccess('Knowledgebase deleted successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to delete knowledgebase');
    } finally {
      dispatch(knowledgebaseLoadingSlice(false));
    }
  };
};
